// NullRenderer renders nothing, but is a valid React element. This component is useful for
// progressive serialization where returning null directly is dangerous.
export const NullRenderer: {
	(): null;
	displayName: string;
} = () => null;
NullRenderer.displayName = 'NullRenderer';
